import type { AnyItem, DisplayTemplateRenderPlan } from '#layers/data-model/public';
import { resolveDisplayTemplateRenderPlan } from '#layers/data-model/public';

/**
 * Returns a cell's value only when the column renders a single field. Anything else (relations,
 * thumbnails, composite templates) returns undefined.
 */
export function resolveCellPrimitiveValue(renderPlan: DisplayTemplateRenderPlan, item: AnyItem): unknown {
	const nodes = resolveDisplayTemplateRenderPlan(renderPlan, item);
	if (nodes.length !== 1) return undefined;

	const [node] = nodes;
	if (!node || !('fieldId' in node)) return undefined;

	return node.value;
}
